
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

const SelectConditionOperator = ({
    conditionOperators,
    label,
    onChange,
    placeholder,
    value
}) => {

    React.useEffect(() => {
        const selectedValue = getSelectedValue();

        if (value !== selectedValue) {
            onChange(selectedValue);
        }
    }, [value]);

    const getOptions = () => {
        return conditionOperators.map(item => {
            return {
                key: item.key,
                text: item.title
            }
        });
    }

    const getSelectedValue = () => {
        return value;
    }

    const handleChange = (evt, option, index, value) => {
        if (onChange) {
            onChange(option.key);
        }
    }

    return (
        <ComboBox
            label={label || 'Operátor'}
            placeholder={placeholder || 'Vyberte operátor podmínky'}
            selectedKey={getSelectedValue()}
            options={getOptions()}
            onChange={handleChange}
        />
    );
}

export default SelectConditionOperator;
